import { Controller } from "@hotwired/stimulus";

// Adds/removes rows in a Rails nested-attributes form. A hidden <template> holds
// a blank row whose field names contain a NEW_RECORD placeholder; "add" clones it
// with a unique index. "remove" deletes a not-yet-persisted row outright, or marks
// a persisted row for destruction (sets its _destroy field) and hides it.
// Button wiring is declarative via data-action; Stimulus binds dynamically-added
// rows automatically, so no manual addEventListener is needed.
export default class extends Controller {
  static targets = ["list", "template"];

  add(event) {
    event.preventDefault();
    // A monotonic per-controller counter keeps each added row's index unique
    // even when clicks land in the same millisecond (a bare timestamp could
    // collide and make submitted rows overwrite one another). Kept numeric so
    // it forms a valid nested-attributes index.
    this.nextIndex = (this.nextIndex ?? Date.now()) + 1;
    const html = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      this.nextIndex,
    );
    this.listTarget.insertAdjacentHTML("beforeend", html);
  }

  remove(event) {
    event.preventDefault();
    const row = event.target.closest("[data-nested-row]");
    if (!row) return;

    const idField = row.querySelector("input[name*='[id]']");
    if (idField && idField.value) {
      // Persisted record: mark for destruction and hide it.
      const destroyField = row.querySelector("input[name*='_destroy']");
      if (destroyField) destroyField.value = "1";
      row.style.display = "none";
    } else {
      // New, unsaved row: remove from the DOM entirely.
      row.remove();
    }
  }
}
